import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import styles from './TagCondition.module.less';

const { Paragraph } = Typography;

function TagCondition({ type }) {

  const { t } = useTranslation();
  const bgColor = type === 'o' ? 'blue' : 'orange';

  return (
    <div className={`${styles.wrapper} ${styles[bgColor]}`}>
      <Paragraph className={styles.title} strong>
        {type === 'o' && t('views.dynamic_alarms_create_edit.tags_conditions.or')}
        {type === 'y' && t('views.dynamic_alarms_create_edit.tags_conditions.and')}
      </Paragraph>
    </div>
  );

}

TagCondition.propTypes = {
  type: PropTypes.oneOf(['o', 'y']),
};

TagCondition.defaultProps = {
  type: 'o',
};

export default TagCondition;
